import type { HTTP } from "@/core/http";
import type {
  Skill,
  SkillHistory,
  SkillRequest,
  SkillUpdateRequestBody,
  SkillsMetadata,
} from "../types";

export class SkillService {
  constructor(private readonly httpClient: HTTP) {}

  async getSkills(): Promise<Skill[]> {
    return this.httpClient.get<Skill[]>("/platform/skills");
  }

  async getSkillMetadata(): Promise<SkillsMetadata> {
    return this.httpClient.get<SkillsMetadata>("/platform/skills/metadata");
  }

  async getSkill(skillId: number): Promise<Skill> {
    return this.httpClient.get<Skill>(`/platform/skills/${skillId}`);
  }

  async createSkill(data: SkillRequest): Promise<Skill> {
    return this.httpClient.post<Skill, SkillRequest>("/platform/skills", {
      body: data,
    });
  }

  async updateSkill(
    skillId: number,
    data: SkillUpdateRequestBody,
  ): Promise<Skill> {
    return this.httpClient.put<Skill, SkillUpdateRequestBody>(
      `/platform/skills/${skillId}`,
      { body: data },
    );
  }

  async getSkillHistory(skillId: number): Promise<SkillHistory[]> {
    return this.httpClient.get<SkillHistory[]>(
      `/platform/skills/${skillId}/history`,
    );
  }
}

export type { Skill };
